import { cssVar, defineStyleConfig } from '@chakra-ui/react';

const $arrowBg = cssVar('popper-arrow-bg');

export const styleConfig = defineStyleConfig({
  baseStyle: {
    background: 'grey.900',
    color: 'white',
    px: '3',
    py: '2.5',
    borderRadius: 'md',
    [$arrowBg.variable]: '#222222',
  },
});
